// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"93713771","483":"c19d83a2","597":"f6d36de6","706":"703ceb3d","737":"213f3b46","894":"09ce48cc","922":"89337566"}[chunkId] + ".chunk.js";
};